import axios from 'axios'
import { DESBLOQUEAR_USUARIO} from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idUsuario, idEmpresa) => dispach =>
  axios.get(`${URL}/usuarios/${idUsuario}/empresa/${idEmpresa}/desbloquear`,SLOW_REQUEST_CONFIG)
    .then( reponse => dispach({
        type: DESBLOQUEAR_USUARIO,
        payload: reponse
  }));
